import { SkuT } from '@lambda/apis/src/catalog-v2/types';
import { ProductSource } from '@/lib/analytics/types';
import RecommendedCard from '@/components/v2/cart/LeftSection/RecommendedCard';

const GRID =
  'grid grid-cols-1 gap-3 lg:gap-4 [@media(min-width:450px)_and_(max-width:799px)]:grid-cols-2 [@media(min-width:800px)]:grid-cols-4';

/** Stands in for the next row of cards while they load. */
export const AccessoryGridPlaceholder = ({ count = 4 }: { count?: number }) => (
  <div className={GRID} aria-hidden>
    {Array.from({ length: count }, (_, index) => (
      <div
        key={index}
        className="h-[260px] animate-pulse rounded-lg bg-[#E6E7EB]"
      />
    ))}
  </div>
);

/** The purchase flow's accessory cards: one per SKU, four across on desktop. */
const AccessoryGrid = ({
  skus,
  parentLineId,
  source,
  slotOffset = 0,
  isAccessory = false,
}: {
  skus: SkuT[];
  parentLineId?: string;
  source: ProductSource;
  slotOffset?: number;
  /** See RecommendedCard's `isAccessory`. */
  isAccessory?: boolean;
}) => (
  <div className={GRID}>
    {skus.map((sku, index) => {
      const offer = sku.offers?.[0];

      if (!offer || !sku.product) {
        return null;
      }

      return (
        <RecommendedCard
          key={sku.id}
          size="lg"
          sku={sku}
          offer={offer}
          product={sku.product}
          slotNumber={slotOffset + index + 1}
          parentLineId={parentLineId}
          source={source}
          isAccessory={isAccessory}
        />
      );
    })}
  </div>
);

export default AccessoryGrid;
